// Copyright (c) 2026 Optimum Healthcare IT. All rights reserved.
// Author: Frank Scalzo <Optimum Healthcare IT>
// License: proprietary
// provenance-id: 85e0550a-543a-45a0-bdcf-c93c937710cf

import React, { useMemo } from 'react';
import ReactFlow, { Background, Controls } from 'reactflow';
import 'reactflow/dist/style.css';
import { typeMeta, relationMeta } from './schema';

// Radial graph: focused fact sheet at center, related fact sheets around it,
// grouped by relation type. Click a node to navigate.
export default function RelationsExplorer({ fs, onOpen }) {
  const { nodes, edges } = useMemo(() => {
    const rels = fs.resolvedRelations || {};
    const items = [];
    Object.entries(rels).forEach(([relKey, arr]) => {
      (arr || []).forEach((it) => items.push({ ...it, relKey }));
    });

    const center = typeMeta(fs.type);
    const nodes = [
      {
        id: fs.id,
        position: { x: 0, y: 0 },
        data: { label: fs.name },
        style: {
          background: center.color, color: '#fff', border: 'none', borderRadius: 8,
          fontWeight: 700, width: 180, fontSize: 12,
        },
      },
    ];
    const edges = [];
    const R = 230;
    const n = Math.max(items.length, 1);
    items.forEach((it, i) => {
      const angle = (i / n) * 2 * Math.PI - Math.PI / 2;
      const m = typeMeta(it.type);
      nodes.push({
        id: it.id,
        position: { x: Math.cos(angle) * R + 260, y: Math.sin(angle) * (R * 0.7) + 10 },
        data: { label: it.name },
        style: { background: '#fff', border: `2px solid ${m.color}`, borderRadius: 8, width: 170, fontSize: 11 },
      });
      edges.push({
        id: `${fs.id}-${it.id}`,
        source: fs.id, target: it.id,
        label: relationMeta(it.relKey)?.label,
        labelStyle: { fontSize: 9, fill: '#888' },
        style: { stroke: '#bbb' },
      });
    });
    return { nodes, edges };
  }, [fs]);

  if (nodes.length <= 1) {
    return <div style={{ color: '#aaa', fontSize: 13, padding: '8px 0' }}>No relationships yet.</div>;
  }

  return (
    <div style={{ height: 320, width: '100%' }}>
      <ReactFlow
        nodes={nodes}
        edges={edges}
        fitView
        nodesDraggable={false}
        zoomOnScroll={false}
        panOnScroll={false}
        preventScrolling={false}
        onNodeClick={(_, node) => node.id !== fs.id && onOpen(node.id)}
        proOptions={{ hideAttribution: true }}
      >
        <Background gap={16} color="#eee" />
        <Controls showInteractive={false} />
      </ReactFlow>
    </div>
  );
}
